@if (pageReady) {
  <main class="gs-page">
    <div class="gs-page-inner">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification></app-notification>
      </div>
      <div class="gs-content-container">
        <div class="left-content">
          <div class="plan-desc">
            <h2>{{ pageLabels.subheader }}</h2>
            @if (accountDetail.PastDueBalance ?? 0 > 0) {
              <p>{{ pageLabels.pastDuePayPlanDescription }}</p>
            } @else {
              <p>{{ pageLabels.payPlanDescription }}</p>
            }
          </div>
          <div class="plan-details">
            <mat-divider></mat-divider>
            <div class="plan-info">
              <div class="due-date">
                <h3>{{ pageLabels.dueDateLabel }}</h3>
                <p>{{ accountDetail.PayPlanDueDate | date: "EEEE, MMM dd, yyyy" }}</p>
              </div>
              <mat-divider></mat-divider>
              <div class="past-due">
                <h3>{{ pageLabels.pastDueAmountLabel }}</h3>
                <p>{{ accountDetail.PayPlanAmount | currency }}</p>
              </div>
            </div>
            <mat-divider></mat-divider>
          </div>
          <div class="disclaimers">
            <h3>{{ pageLabels.termsHeader }}</h3>
            <p>{{ pageLabels.termsDescription }}</p>
            <h3>{{ pageLabels.lateFeesHeader }}</h3>
            <p>{{ pageLabels.lateFeesDescription }}</p>
          </div>
          <form [formGroup]="payplanForm" class="checkbox-container">
            <mat-checkbox aria-labelledby="checkbox-error" formControlName="terms" color="primary">{{
              pageLabels.termsCheckboxLabel
            }}</mat-checkbox>
            @if (showInlineError) {
              <mat-error id="checkbox-error">{{ pageLabels.termsUnselectedError }}</mat-error>
            }
          </form>
          <div class="button-container">
            <button class="gs-form-button-primary" mat-flat-button color="primary" (click)="submitPayPlan()">
              {{ pageLabels.ctaButtonText }}
            </button>
          </div>
        </div>
        <app-side-panel [panelData]="panelData"></app-side-panel>
      </div>
    </div>
  </main>
}
